// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Fragment } from 'react';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
import { arrayMove } from './ArrayMove';

const Grid = styled.div`
  display: grid
  grid-template-columns: repeat(4, 2fr) !important;
  gap: 16px !important;
  padding-left: 30px;
  
  @media (max-width: 768px) {
    display: block;
    padding-left: 0;
  }
`;

const GridItem = styled.div`
  height: 200px;

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
    margin-bottom: 20px;

    .ph-elem {
      width: 100%;
    }

    .grid_photo {
      width: 100%;
      height: 100%;
    }
  }
`;

const SortableItem = SortableElement(({ Element, ...props }) => (
  <GridItem>
    <Element {...props} />
  </GridItem>
));

const SortableGrid = SortableContainer(({ content, ...props }) => (
  <Grid>
    {content.map((value, index) => (
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/jsx-key
      <Fragment>
        <SortableItem
          key={`item-${value.id}`}
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          myKey={`item-${value.id}`}
          index={index}
          value={value}
          {...props}
        />
      </Fragment>
    ))}
  </Grid>
));

export default class DragnDropGrid extends React.Component {
  onSortEnd = ({ oldIndex, newIndex }) => {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { onChange, content, receiver } = this.props;
    const newArray = arrayMove(content, oldIndex, newIndex);
    onChange({
      [receiver]: newArray,
    });
  };

  render() {
    const { ...props } = this.props;
    return (
      <SortableGrid
        onSortEnd={this.onSortEnd}
        distance={1}
        axis='xy'
        {...props}
      />
    );
  }
}
